import { makeStyles } from '@mui/styles';
import Blade from 'apollo-react/components/Blade';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import FormChangesTabs from './FormChangesTabs';
import { ENTITY_DISPLAY } from '../../../constants/Urls';
import { useFormSelector } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { FORM_KEYS } from '../../constants/form-manager.constants';
import { FormContext } from '../../context';
import {
  getDeltaChanges,
  getIsFormChangesMode,
  getLayoutChanges,
} from '../../selectors/common.selectors';
import { getFormChangesBladeDefaultTab } from '../../utils/runtime.utils';

const useStyles = makeStyles({
  root: {
    zIndex: 2001,
    position: 'relative',
  },
});

const FormChangesBlade = () => {
  const classes = useStyles();
  const translateString = useTranslation();
  const { pathname } = useLocation();
  const formKey = useContext(FormContext);

  const deltaChanges = useFormSelector(getDeltaChanges);
  const layoutChanges = useFormSelector(getLayoutChanges);
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);

  const [isExpanded, setIsExpanded] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (!isFormChangesMode) {
      setCurrentTab(getFormChangesBladeDefaultTab(deltaChanges, layoutChanges));
    }
  }, [isFormChangesMode, deltaChanges, layoutChanges]);

  const formType = formKey === FORM_KEYS.STEP ? 'Step' : 'Detail';
  const title = translateString(
    `${pathname === ENTITY_DISPLAY ? formType : ''} Form Delta Changes`
  );

  return (
    <Blade
      className={classes.root}
      title={title}
      open={isFormChangesMode}
      expanded={isExpanded}
      width={window.innerWidth * 0.6}
      BackdropProps={{ style: { zIndex: 2000 } }}
      hasBackdrop
      hideCloseButton
      onChange={(_, expanded) => setIsExpanded(expanded)}
    >
      <FormChangesTabs
        currentTab={currentTab}
        handleTabChange={(_, tabValue) => setCurrentTab(tabValue)}
        collapseBlade={() => setIsExpanded(false)}
      />
    </Blade>
  );
};

export default FormChangesBlade;
